var $ = require('js/sw-jquery/sw-jquery');

if ($.browser.msie && $.browser.version <= 10) {
  $(".fancybox").fancybox();
  $("#browser-redirect").fancybox().trigger('click');
}
